module.exports = __webpack_public_path__ + "img/main_5.eb0a0801.png";